/**
 * Navigator snapshot for an in-doc table — same idea as the variables
 * miniature: chrome card, header stubs, then body cells using live column
 * widths. Cells are `.table-cell-canvas` (not the retired `.table-cell-content`).
 */

export const isTableChromeCell = (el) =>
  el.classList.contains('table-add-col-cell') ||
  el.classList.contains('table-row-actions');

export const tableDataCells = (tr) => {
  if (!tr) return [];
  return Array.from(tr.querySelectorAll(':scope > th, :scope > td')).filter(
    (el) => !isTableChromeCell(el)
  );
};

const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim();

export const cellStubWidth = (text, colPx, { upload = false } = {}) => {
  const t = cleanText(text);
  if (!t) return upload ? 0.55 : 0.14;
  const budget = Math.max(3, Math.floor(colPx / 7));
  return Math.min(1, Math.max(0.2, t.length / budget));
};

export const describeTableCell = (cell, colPx, colorForPill) => {
  if (!cell) return { width: 0.14, color: null, upload: false, src: null };
  const upload = cell.querySelector('.file-upload-block');
  const img = cell.querySelector(
    '.file-upload-block__thumb img, .image-block img, .table-cell-canvas img'
  );
  const pill = cell.querySelector('[data-doc-variable], [data-doc-math]');
  const label = upload?.querySelector('.file-upload-block__label');
  const fileName = upload?.querySelector('.file-upload-block__file-name');
  const text =
    cleanText(fileName?.textContent) ||
    cleanText(label?.textContent) ||
    cleanText(cell.textContent);
  return {
    width: cellStubWidth(text, colPx, { upload: !!upload }),
    color: pill && colorForPill ? colorForPill(pill) : null,
    upload: !!upload,
    src: img?.currentSrc || img?.src || null,
  };
};

export const snapshotDocTable = (tableRoot, rootW, colorForPill) => {
  const headerRow = tableRoot.querySelector('thead tr');
  const headerCells = tableDataCells(headerRow);
  const bodyRows = Array.from(tableRoot.querySelectorAll('tbody tr'));
  const widths = headerCells.map((el) => el.getBoundingClientRect().width);
  const widthSum = widths.reduce((sum, w) => sum + w, 0);
  const colFracs =
    widthSum > 0
      ? widths.map((w) => w / Math.max(1, rootW))
      : headerCells.map(() => 1 / Math.max(1, headerCells.length));
  const cols = Math.max(1, headerCells.length, ...bodyRows.map((tr) => tableDataCells(tr).length));

  const describeRow = (cells) => {
    const padded = [...cells];
    while (padded.length < cols) padded.push(null);
    return padded.slice(0, cols).map((cell, i) => {
      const colPx = (colFracs[i] || 1 / cols) * rootW;
      if (!cell) return { width: 0.14, color: null, upload: false, src: null };
      return describeTableCell(cell, colPx, colorForPill);
    });
  };

  const header = { cells: describeRow(headerCells) };
  const rows = bodyRows
    .map((tr) => ({ cells: describeRow(tableDataCells(tr)) }))
    .filter((row) => row.cells.length > 0);
  const hasAdd = !!tableRoot.querySelector('.table-add-row-btn-bottom');

  return {
    colFracs,
    header,
    rows,
    empty: rows.length === 0,
    hasAdd,
  };
};
